import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

let hasInitialisedPostHog = false;

export function isPostHogEnabled() {
  return Boolean(POSTHOG_KEY && POSTHOG_HOST);
}

export function initPostHog() {
  if (
    hasInitialisedPostHog ||
    typeof window === "undefined" ||
    !isPostHogEnabled()
  ) {
    return;
  }

  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: "2025-05-24",
    capture_pageview: "history_change",
    cross_subdomain_cookie: true,
    persistence: "localStorage+cookie",
    person_profiles: "identified_only",
    mask_all_text: true,
    mask_all_element_attributes: true,
    loaded: (client) => {
      client.register({
        surface: "app",
        app_host: window.location.hostname,
      });
    },
  });

  hasInitialisedPostHog = true;
}

export { posthog };
